import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

// Styles
import "./add-customer-tabs.styles.scss";

const AddCustomerTabs = ({ subscriptionStepEnabled }) => {
  return (
    <div className="add-customer__tabs">
      <ul>
        <li>
          <NavLink
            exact
            activeClassName="add-customer__active"
            to="/manage-customers/add-customer-info"
          >
            Customer Information
          </NavLink>
        </li>
        <li>
          {subscriptionStepEnabled ? (
            <NavLink
              exact
              activeClassName="add-customer__active"
              to="/manage-customers/subscription-and-billing-info"
            >
              Subscription And Billing Information
            </NavLink>
          ) : (
            <span className="add-customer__tab--disabled">
              Subscription And Billing Information
            </span>
          )}
        </li>
      </ul>
    </div>
  );
};

AddCustomerTabs.propTypes = {
  subscriptionStepEnabled: PropTypes.bool.isRequired
};

export default AddCustomerTabs;
